import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 存储token
    CurrPageTitle: sessionStorage.getItem('CurrPageTitle') ? sessionStorage.getItem('CurrPageTitle') : '简介',
    CurrDepartName: sessionStorage.getItem('CurrDepartName') ? sessionStorage.getItem('CurrDepartName') : '财务金融系',
    CurrDepartPath: sessionStorage.getItem('CurrDepartPath') ? sessionStorage.getItem('CurrDepartPath') : '/cwjr',
    ListLoading: true,
    detailLoading: true,
    mobileMenuFlag: false
  },
  mutations: {
    // 状态变化函数
    changePageTitle (state, title) {
      state.CurrPageTitle = title
      sessionStorage.setItem('CurrPageTitle', title)
    },
    changeDepartName (state, name) {
      state.CurrDepartName = name
      sessionStorage.setItem('CurrDepartName', name)
    },
    changeDepartPath (state, path) {
      state.CurrDepartPath = path
      sessionStorage.setItem('CurrDepartPath', path)
    },
    showListLoading (state, flag) {
      state.ListLoading = flag
    },
    showDetailLoading (state, flag) {
      state.detailLoading = flag
    },
    showmobileMenu (state, flag) {
      state.mobileMenuFlag = flag
    }
  },
  actions: {
    // Acount (context) {
    // context.commit('Count ')
    // }
  },
  modules: {
  }
})
